import React, { Component } from 'react'
import { connect } from 'react-redux'
import NotificationSystem from 'react-notification-system'
import InfoIcon from '@material-ui/icons/Info'
import { style } from 'variables/Variables'
import { clearNotice } from 'reducers/notice'
import './Notice.scss'

class Notice extends Component {
  notificationSystem = React.createRef()

  componentDidUpdate() {
    this.showNotice(this.props.notice)
  }

  showNotice = notice => {
    if (!notice) {
      return null
    }

    const notification = this.notificationSystem.current

    notification.addNotification({
      title: <InfoIcon className="notify-icon" />,
      message: <div>{notice.message}</div>,
      level: notice.type,
      position: 'tr',
      autoDismiss: 2,
    })
    this.props.clearNotice()
  }

  render() {
    return <NotificationSystem ref={this.notificationSystem} style={style} />
  }
}

export default connect(
  state => ({
    notice: state.getIn(['notice', 'notice']),
  }),
  {
    clearNotice,
  },
)(Notice)
